import {cloneDeep} from 'lodash';
import {StringUtils} from 'src/js/common/utils';

export const ERROR_MESSAGE = 'message';
export const ERROR_STACK = 'stack';

const ERROR_MESSAGE_MAX_LENGTH = 50;

export class DlError {
  private rawData: Record<string, any>;

  private id: string | undefined;

  private category: string | undefined;

  private timestamp: Date | number;

  constructor(
    rawData: Record<string, any> | string = {},
    id: string | undefined = undefined,
    category: string | undefined = undefined,
    timestamp: Date | number = new Date()
  ) {
    const errorData = rawData ?? {};
    // copy error properties as they are not enumerable
    this.rawData =
      typeof rawData === 'string'
        ? {[ERROR_MESSAGE]: rawData}
        : {
            ...(errorData as Record<string, any>),
            [ERROR_MESSAGE]: errorData[ERROR_MESSAGE],
            [ERROR_STACK]: errorData[ERROR_STACK],
          };
    this.id = id;
    this.category = category;
    this.timestamp = timestamp;
  }

  clone() {
    return Object.assign(new DlError(cloneDeep(this.rawData), this.id, this.category), this);
  }

  getId() {
    return this.id;
  }

  getCategory() {
    return this.category;
  }

  getMessage(trim = false) {
    return trim ? StringUtils.trimWithoutCuttingWord(this.rawData[ERROR_MESSAGE], ERROR_MESSAGE_MAX_LENGTH) : this.rawData[ERROR_MESSAGE];
  }

  getTitleMessage() {
    return `${this.category}: ${this.rawData[ERROR_MESSAGE]}`;
  }

  getRawError() {
    return this.rawData;
  }

  getStack() {
    return this.rawData[ERROR_STACK];
  }

  getTimestamp() {
    return this.timestamp;
  }
}

export default {DlError};
